/* ============================================================
   Carrousels de cartes produit (sélections, produits liés) :
   flèches (pas d'une carte ou d'une page), flèches désactivées aux
   extrémités, défilement automatique (pause au survol / focus),
   retour au début en option. Respecte prefers-reduced-motion.
   Markup : [data-carrousel] > .carrousel + [data-car-fleche][data-sens].
   ============================================================ */
(function () {
  'use strict';
  if (window.mdmCarrousels) { window.mdmCarrousels(document); return; }

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Carrousel(racine) {
    var piste = racine.querySelector('.carrousel');
    if (!piste) return;
    var fleches = racine.querySelectorAll('[data-car-fleche]');
    var pas = racine.dataset.pas === 'page' ? 'page' : 'carte';
    var boucle = racine.dataset.boucle === '1';
    var auto = racine.dataset.auto === '1' && !reduit;
    var delai = (parseInt(racine.dataset.delai, 10) || 5) * 1000;
    var minuterie = null;
    var pause = false;
    var rafId = 0;

    function largeurPas() {
      var carte = piste.querySelector('.carte');
      if (!carte) return piste.clientWidth;
      var gap = parseFloat(getComputedStyle(piste).columnGap) || 0;
      var une = carte.getBoundingClientRect().width + gap;
      if (pas === 'page') return Math.max(une, Math.floor(piste.clientWidth / une) * une);
      return une;
    }
    function maj() {
      rafId = 0;
      var max = piste.scrollWidth - piste.clientWidth - 2;
      var debut = piste.scrollLeft <= 2;
      var fin = piste.scrollLeft >= max;
      fleches.forEach(function (b) {
        var sens = +b.dataset.sens;
        b.disabled = !boucle && ((sens < 0 && debut) || (sens > 0 && fin));
      });
      racine.classList.toggle('car--sans-defilement', max <= 0);
    }
    function planifier() { if (!rafId) rafId = requestAnimationFrame(maj); }
    function aller(sens) {
      var max = piste.scrollWidth - piste.clientWidth - 2;
      var cible;
      if (boucle && sens > 0 && piste.scrollLeft >= max) cible = 0;
      else if (boucle && sens < 0 && piste.scrollLeft <= 2) cible = max;
      else cible = piste.scrollLeft + sens * largeurPas();
      piste.scrollTo({ left: cible, behavior: reduit ? 'auto' : 'smooth' });
    }
    fleches.forEach(function (b) {
      b.addEventListener('click', function () { aller(Math.sign(+b.dataset.sens)); relancer(); });
    });
    piste.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);

    function relancer() {
      clearInterval(minuterie);
      if (!auto) return;
      minuterie = setInterval(function () {
        if (pause || document.hidden) return;
        var max = piste.scrollWidth - piste.clientWidth - 2;
        if (max <= 0) return;
        if (piste.scrollLeft >= max) piste.scrollTo({ left: 0, behavior: reduit ? 'auto' : 'smooth' });
        else aller(1);
      }, delai);
    }
    if (auto) {
      racine.addEventListener('mouseenter', function () { pause = true; });
      racine.addEventListener('mouseleave', function () { pause = false; });
      racine.addEventListener('focusin', function () { pause = true; });
      racine.addEventListener('focusout', function () { pause = false; });
      racine.addEventListener('touchstart', function () { pause = true; }, { passive: true });
      racine.addEventListener('touchend', function () { setTimeout(function () { pause = false; }, 4000); }, { passive: true });
      relancer();
    }
    /* le contenu (cartes) peut arriver après coup */
    if (window.MutationObserver) new MutationObserver(planifier).observe(piste, { childList: true });
    maj();
  }

  window.mdmCarrousels = function (zone) {
    (zone || document).querySelectorAll('[data-carrousel]').forEach(function (r) {
      if (r.__mdmCar) return;
      r.__mdmCar = true;
      Carrousel(r);
    });
  };

  window.mdmCarrousels(document);
  document.addEventListener('shopify:section:load', function (e) { window.mdmCarrousels(e.target); });
})();
